import { useCallback, useState } from "react";

export const useStorage = <T extends object>(
  storage: Storage | undefined,
  key: string,
  getInitialValue: () => T,
): [T, (value: T) => void] => {
  const [storedValue, setStoredValue] = useState<T>(() => {
    if (typeof storage === "undefined") {
      // for SSR we return the default value
      return getInitialValue();
    }

    const item = localStorage.getItem(key);

    return item ? JSON.parse(item) : getInitialValue();
  });

  const setValue = useCallback(
    (value: T) => {
      // store the new value in the storage
      storage?.setItem(key, JSON.stringify(value));

      // set in the react state
      setStoredValue(value);
    },
    [storage, key],
  );

  return [storedValue, setValue];
};
